/**
 * @file Table feature: general info.
 * @since 3.7.0
 */

import TableAbstractFeature from './TableAbstractFeature';

export default class TableInfo extends TableAbstractFeature {
  constructor(table) {
    super(table);
  }

  /**
   * @public
   */
  init() {
    this._render();
    this._addEventListeners();
    this._updateInfo();
  }

  /**
   * @public
   */
  destroy() {
    this._removeEventListeners();
  }

  /**
   * @private
   */
  _addEventListeners() { }

  /**
   * @private
   */
  _removeEventListeners() { }

  get totalNum() {
    return this.component.model.data.length;
  }

  get showNum() {
    if (this.component.model.data.length === 0) {
      return '0';
    }

    let start = 1;
    let end = this.component.model.data.length;

    if (this.component.pagination) {
      start = this.component.pagination.state.numPerPage * (this.component.pagination.state.currentPage - 1) + 1;
      end = Math.min(this.component.model.data.length,
        this.component.pagination.state.numPerPage * this.component.pagination.state.currentPage);
    }
    return `${start} – ${end}`;
  }

  get selectNum() {
    return this.component.model.data.filter((d) => d.selected).length;
  }

  /**
   * @private
   */
  _render() {
    this.dom.tableInfo.innerHTML = `<span class="count-show"></span><span class="count-total"></span>
        <span class="count-selected"></span>`;
  }

  /**
   * @private
   */
  _updateInfo() {
    this._updateNumShow();
    this._updateNumTotal();
    this._updateNumSelected();
  }

  /**
   * @private
   */
  _updateNumShow() {
    if (this.dom.tableInfo.querySelector('.count-show')) {
      this.dom.tableInfo.querySelector('.count-show').textContent = `${this.showNum}`;
    }
  }

  /**
   * @private
   */
  _updateNumTotal() {
    if (this.dom.tableInfo.querySelector('.count-total')) {
      this.dom.tableInfo.querySelector('.count-total').textContent = ` of ${this.totalNum} items`;
    }
  }

  /**
   * @private
   */
  _updateNumSelected() {
    if (this.dom.tableInfo.querySelector('.count-selected')) {
      this.dom.tableInfo.querySelector('.count-selected').textContent = this.selectNum ?
        ` | ${this.selectNum} selected` : '';
    }
  }

  /**
   * From observer Table.js
   */

  onCreatedBody() {
    this._updateInfo();
  }

  onToggleSelectRow() {
    this._updateInfo();
  }
}
